export var defaultColorPalettes = {
  brand: {
    lightest: '#EFEBFF',
    lighter: '#E4DBFF',
    light: '#9470FF',
    main: '#7849FF',
    dark: '#5F33E6',
    darkest: '#4315CB'
  },
  warning: {
    lightest: '#FFF8E6',
    lighter: '#FFF0CA',
    main: '#FDB702',
    dark: '#E6A702',
    darkest: '#B88501'
  },
  success: {
    lightest: '#DFF5E7',
    lighter: '#B1E2C4',
    main: '#028838',
    dark: '#00702D',
    darkest: '#014B1F'
  },
  info: {
    lightest: '#E6F0FE',
    lighter: '#C7DAFD',
    main: '#306AF7',
    dark: '#2256D6',
    darkest: '#0351C0'
  },
  critical: {
    lightest: '#FDE7E9',
    lighter: '#FAC4C9',
    main: '#EB0F25',
    dark: '#C50C22',
    darkest: '#8D0411'
  },
  neutral: {
    white: '#FFFFFF',
    lightest: '#FAFBFC',
    lighter: '#EEF1F6',
    light: '#D9DEE8',
    dark: '#A6AEBE',
    darker: '#6A7281',
    darkest: '#4A505B',
    black: '#18191B'
  },
  decorative: {
    decorative1: '#EAD6D4',
    decorative2: '#FFE0D6',
    decorative3: '#FFD0EA',
    decorative4: '#D9E1FD',
    decorative5: '#C9F8F8'
  },
  focus: {
    focus: '#0548CF',
    invert: '#3798F2'
  },
  link: {
    rest: 'neutral.black',
    hover: 'brand.main',
    pressed: 'brand.dark'
  },
  avatar: {
    default: 'neutral.darker',
    avatar1: 'decorative.decorative1',
    avatar2: 'decorative.decorative2',
    avatar3: 'decorative.decorative3',
    avatar4: 'decorative.decorative4',
    avatar5: 'decorative.decorative5',
    avatar6: 'neutral.black'
  },
  illustration: {
    stroke: 'neutral.black',
    bg: 'neutral.white',
    main: 'brand.main',
    light: 'brand.lightest',
    success: 'success.main',
    critical: 'critical.main'
  }
};
//# sourceMappingURL=default-color-palettes.js.map